import { all } from 'ramda';
import { isNilOrEmpty } from 'ramda-extension';

import { isRequired } from '@gef-ui/form-core/validations/validationFunctions/common';

import isFirstName from 'app/forms/validations/isFirstName';
import isLogin from 'app/forms/validations/isLogin';
import isSellerIn from 'app/forms/validations/isSellerIn';
import isSurname from 'app/forms/validations/isSurname';
import { COMMON_FORM_FIELD_NAMES } from 'features/common/forms/constants';
import { RADIO_OPTIONS_IDS } from 'features/views/guarantorsEdit/constants';
import { getRadio } from 'features/views/guarantorsEdit/selectors';

export const EDIT_GUARANTOR_FORM_NAME = 'editGuarantor-filter';

const { channel, region, agency, manager, guarantors, firstName, surname, sellerIn, login } = COMMON_FORM_FIELD_NAMES;

export const FIELDS = {
	channel,
	agency,
	region,
	manager,
	guarantors,
	firstName,
	surname,
	sellerIn,
	login,
};

export default () => ({
	[FIELDS.channel]: {
		deepPath: [FIELDS.channel],
		validations: [],
	},
	[FIELDS.region]: {
		deepPath: [FIELDS.region],
		validations: [],
	},
	[FIELDS.agency]: {
		deepPath: [FIELDS.agency],
		validations: [],
	},
	[FIELDS.manager]: {
		deepPath: [FIELDS.manager],
		validations: [],
	},
	[FIELDS.firstName]: {
		deepPath: [FIELDS.firstName],
		validations: [isFirstName()],
	},
	[FIELDS.surname]: {
		deepPath: [FIELDS.surname],
		validations: [
			isRequired({
				when: ({ formData, reduxState }) =>
					getRadio(reduxState) === RADIO_OPTIONS_IDS.outOrganizeStructure &&
					all(isNilOrEmpty)([formData?.surname, formData?.sellerIn, formData?.login]),
			}),
			isSurname(),
		],
	},
	[FIELDS.sellerIn]: {
		deepPath: [FIELDS.sellerIn],
		validations: [
			isRequired({
				when: ({ formData, reduxState }) =>
					getRadio(reduxState) === RADIO_OPTIONS_IDS.outOrganizeStructure &&
					all(isNilOrEmpty)([formData?.surname, formData?.sellerIn, formData?.login]),
			}),
			isSellerIn(),
		],
	},
	[FIELDS.login]: {
		deepPath: [FIELDS.login],
		validations: [
			isRequired({
				when: ({ formData, reduxState }) =>
					getRadio(reduxState) === RADIO_OPTIONS_IDS.outOrganizeStructure &&
					all(isNilOrEmpty)([formData?.surname, formData?.sellerIn, formData?.login]),
			}),
			isLogin(),
		],
	},
});
